import { useState, useEffect, useRef } from 'react'
import api from '../../../utils/api'

// Variante de AuthImage.js pro padrão de thumbnail do hasteg, que usa
// background-image em vez de <img src> — precisa ser um componente (não um
// hook puro) porque a maioria dos usos fica dentro de .map() em listas, e
// hooks não podem ser chamados em loop.
function AuthBackgroundImage({ src, className, style, onClick, children }) {
    const [objectUrl, setObjectUrl] = useState(null)
    const [visible, setVisible] = useState(false)
    const elRef = useRef(null)

    // Só busca a imagem quando o elemento entra (ou já está) na tela — uma lista
    // com centenas de cards não deve disparar centenas de requisições autenticadas
    // de uma vez só no carregamento da página. rootMargin antecipa um pouco a
    // busca antes do card ficar 100% visível, pra não piscar em branco ao rolar.
    useEffect(() => {
        const el = elRef.current
        if (!el) return

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setVisible(true)
                observer.disconnect()
            }
        }, { rootMargin: '200px' })

        observer.observe(el)
        return () => observer.disconnect()
    }, [])

    useEffect(() => {
        if (!src || !visible) {
            if (!src) setObjectUrl(null)
            return
        }

        let cancelled = false
        let currentUrl = null
        const token = localStorage.getItem('token')

        api.get(src, {
            responseType: 'blob',
            headers: token ? { Authorization: `Bearer ${JSON.parse(token)}` } : {},
        }).then((response) => {
            if (cancelled) return
            currentUrl = URL.createObjectURL(response.data)
            setObjectUrl(currentUrl)
        }).catch(() => {
            if (!cancelled) setObjectUrl(null)
        })

        return () => {
            cancelled = true
            if (currentUrl) URL.revokeObjectURL(currentUrl)
        }
    }, [src, visible])

    return (
        <div
            ref={elRef}
            className={className}
            style={{ ...style, backgroundImage: objectUrl ? `url(${objectUrl})` : undefined }}
            onClick={onClick}
        >
            {children}
        </div>
    )
}

export default AuthBackgroundImage
